import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, color = 'primary' }) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-center justify-between mb-4">
        <div className={`h-12 w-12 rounded-lg bg-${color}/10 flex items-center justify-center`}>
          <Icon name={icon} size={24} className={`text-${color}`} />
        </div>
        {trend && (
          <div className={`flex items-center space-x-1 text-sm ${
            trend?.type === 'up' ? 'text-success' : trend?.type === 'down' ? 'text-destructive' : 'text-muted-foreground'
          }`}>
            {trend?.type === 'up' && <Icon name="TrendingUp" size={16} />}
            {trend?.type === 'down' && <Icon name="TrendingDown" size={16} />}
            <span>{trend?.value}</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <h3 className="text-2xl font-bold text-foreground">{value}</h3>
        <p className="text-sm text-muted-foreground">{title}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;